import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { LocationService } from '../../services/location.service';
import { PackingEcService } from '../../services/packingec.service';
import { PalletsService } from '../../services/pallets.service';
import { TagsService } from '../../services/tags.service';
import { StockService } from '../../services/stock.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';

@Component({
  selector: 'controlproduccion',
  templateUrl: './controlproduccion.component.html',
  styleUrls: ['./controlproduccion.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ControlproduccionComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  public load:number;
  public myAngularxQrCode: string;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public signupForm2:FormGroup;
  public signupForm3:FormGroup;
  public signupForm4:FormGroup;
  public signupFormMov0:FormGroup;
  public signupFormMov1:FormGroup;
  public signupFormMov2:FormGroup;
  public signupFormMov3:FormGroup;
  public signupFormMov3b:FormGroup;
  public signupFormSal0:FormGroup;
  public signupFormSal1:FormGroup;
  public signupFormBuscar:FormGroup;
  public signupFormCuadrarPallet:FormGroup;
  public cajas:any[];
  public pallets:any[];
  public tarea:boolean;
  public buscar:boolean;
  public entrada:boolean;
  public movimiento:boolean;
  public salida:boolean;
  public title2:string;
  public title3:string;
  public locaciones:any[];
  public packings:any[];
  public tags:any[];
  public contadortags:number;
  public palletsconcajas: any[];
  public ubicacionesconcajas: any[];
  public posiciones: any[];
  public palletacompletar: number;
  public ubicacionacompletar: number;
  public etapa:number;
  public etapamov:number;
  public etapasal:number;
  public cajas2:any[];
  public pallets2:any[];
  public cajas3:any[];
  public pallets3:any[];
  public positions:any[];
  public salidas:any[];
  public palletubicados:any[];
  public paso1:boolean;
  public paso2:boolean;
  public paso1mov:boolean;
  public paso2mov:boolean;
  public paso3mov:boolean;
  public paso4mov:boolean;
  public op:any[];
  public palletencontrado:boolean;
  public posicionesvacias:any[];
  public palletsnuevos:any[];
  public posicionespalletsvacios:any[];
  public ispalletnuevo:boolean;
  public palletsaeliminar:any[];
  public packingpallet:any[];
  public corregir:boolean;
  public namepackingpallet:string;
  public newpackingpallet:any[];
  public trabajando :boolean;
  public cajasaeliminar: any[];
  public sinpacking:boolean;

  constructor(private _stockService:StockService,private _palletsService:PalletsService,private _tagsService:TagsService,private _packingecService:PackingEcService,private _locationService:LocationService,private _localeService: BsLocaleService,private _loaddata: LoadService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.myAngularxQrCode = ' ';
    this.tarea = false;
    this.buscar = false;
    this.entrada = false;
    this.movimiento = false;
    this.salida = false;
    this.title2 = "";
    this.title3 = "";
    this.contadortags = 0;
    this.locaciones = [];
    this.packings =[];
    this.tags = [];
    this.palletsconcajas = [];
    this.ubicacionesconcajas = [];
    this.cajas = [];
    this.pallets = [];
    this.posiciones = [];
    this.palletacompletar = -1;
    this.ubicacionacompletar = -1;
    this.etapa = 1;
    this.cajas2 = [];
    this.pallets2 = [];
    this.cajas3 = [];
    this.pallets3 = [];
    this.positions = [];
    this.etapamov = 1;
    this.etapasal = 1;
    this.salidas = [];
    this.palletubicados = [];
    this.paso1 = false;
    this.paso2 = false;
    this.paso1mov = false;
    this.paso2mov = false;
    this.paso3mov = false;
    this.paso4mov = false;
    this.op = [];
    this.palletencontrado = false;
    this.posicionesvacias = [];
    this.palletsnuevos = [];
    this.posicionespalletsvacios = [];
    this.ispalletnuevo = false;
    this.palletsaeliminar = [];
    this.packingpallet = [];
    this.corregir = false;
    this.namepackingpallet = '';
    this.newpackingpallet = [];
    this.trabajando = false;
    this.sinpacking = false;
  }

  ngOnInit() {
    this._loaddata.loadChange(10);
    this._localeService.use('es');
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'busqueda': new FormControl("",Validators.required)
    });
    this.signupForm2 = new FormGroup({
      'busqueda': new FormControl("",Validators.required)
    });

    this.loadData();
  }

  /**
  * Carga el menu de movimientos
  */
  loadData():void{
    if(this.primeracarga === false){
      this.primeracarga = !this.primeracarga;
    }
    this.onEntrada();
  }

  onEntrada():void{
    this.tags = [];
    this.packings = [];
    this.loadIncomePackings();
    this.buscar = false;
    this.entrada = true;
    this.movimiento = false;
    this.salida = false;
  }

  loadIncomePackings():void{
    this.alert = "Cargando Packings."
    this.isopen = true;
    this._loaddata.loadChange(50);
    this._packingecService.getIncomePackings(1).subscribe((response:any) => {
      this._loaddata.loadChange(90);
      for(let pac of response.data){
        if(pac.attributes.total_boxes > 0){
          this.packings.push(pac);
        }
      }
      if(this.packings.length == 0){
        this.sinpacking = true;
      }
      else{
        this.sinpacking = false;
      }
      //console.log("PACKINGS: ", this.packings);
      this.alert = "Carga correcta de Packings."
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  /**
  * Carga todas las cajas relacionadas al packing.
  * @param packing 1 packing de Empaque -> Camara
  */
  onPackingSelected(packing):void{
    this.isopen = true;
    this.alert = 'Cargando etiquetas QR relacionadas al packing '+packing.id+'.';
    this._loaddata.loadChange(40);
    this._tagsService.getTagsFromPacking(packing.id,2).subscribe((response:any) => {
      this.tags = response.data;
      this.contadortags = 0;
      this.alert = 'Carga completa';
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      this.forwardEntrada(1);
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  onCheckTag(){
    let qr = this.signupForm2.get('busqueda').value;
    let guion = 0;
    let prefijo = '';
    let sufijo = '';
    let variable = '';

    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    for (var char of qr) {
      if(char != '-'){
        variable += char;
      }
      else if(guion == 0){
        prefijo = variable;
        variable = '';
        guion = 1;
      }
      else if(guion == 1){
        sufijo = variable;
        variable = '';
        guion = 2;
      }
    }

    for (let tag of this.tags) {
      if(parseInt(tag.attributes.prefix) === parseInt(prefijo)){
        if(parseInt(tag.attributes.suffix) === parseInt(sufijo)){
          if(tag.attributes.tag_status_id == 3){

          }
          else{
            tag.attributes.tag_status_id = 3;
            this.contadortags++;
          break;
          }
        }
      }
    }
    this.signupForm2.reset();
    this.signupForm2.patchValue({
      'busqueda': '',
    });
  }

  onPackingResolve(resp){
    this.trabajando = true;
    this.alert = 'Preparando información.';
    this.isopen = true;
    this._loaddata.loadChange(30);
    let idt = 0;
    let op = [];
    this.pallets = [];
    /*Packing aprobado*/
    if(resp == true){
      this._loaddata.loadChange(40);
      this.alert = 'Cambiando estado ACEPTADO a packing '+this.tags[0].relationships.packing.data.id;
      let prov = this._packingecService.transformData2(4,this.tags[0].relationships.packing.data.id);
      this._packingecService.update2(prov,this.tags[0].relationships.packing.data.id).subscribe(
        (response:any) => {
          this.alert = 'Aceptando etiquetas.';
          let prov2= this._tagsService.transformData7(this.tags,3);
          this._tagsService.update(prov2).subscribe(
            response =>{
              this._loaddata.loadChange(100);
              this.etapa = 1;
              this.entrada = false;
              this.alert = 'Etiquetas QR aceptadas.'
              this.trabajando = false;
              this.onEntrada();
            },
            (error) => {
              this.showError(error.error.error);
              this.trabajando = false;
            }
          );
        },
        (error) => {
          this.showError(error.error.error);
        }
      );

    }/*Packing rechazado*/
    else{
      this._loaddata.loadChange(40);
      this.alert = 'Cambiando estado RECHAZADO a packing '+this.tags[0].relationships.packing.data.id;
      let prov = this._packingecService.transformData2(3,this.tags[0].relationships.packing.data.id);
      this._packingecService.update2(prov,this.tags[0].relationships.packing.data.id).subscribe(
        (response:any) => {
          this.alert = 'Rechazando etiquetas.'
          let prov2= this._tagsService.transformData7(this.tags,4);
          this._tagsService.update(prov2).subscribe(
            response =>{
              this._loaddata.loadChange(100);
              this.etapa = 1;
              this.entrada = false;
              this.alert = 'Etiquetas QR rechazadas.'
              this.trabajando = false;
              this.onEntrada();
            },
            (error) => {
              this.showError(error.error.error);
              this.trabajando = false;
            }
          );
        },
        (error) => {
          this.showError(error.error.error);
        }
      );
    }
    this.onClosedAutomatic();
  }

  reverseEntrada(etapa:number){
    if(etapa == 2){
      this.etapa = 1;
    }
  }

  forwardEntrada(etapa:number){
    if(etapa == 1){
      this.etapa = 2;
    }
  }


  /**
  * Cierra el modal
  */
  hideChildModal(): void {
    this.lgModal.hide();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
    this.onClosedAutomatic();
  }

  /**
  * Actualiza el listado por la paginacion
  * @param data nuevo listado o mensaje de error.
  */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/controlproduccion/controlproduccion.component.ts